'use client';
import { jsx as _jsx } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { initializeApp } from '../../core/thunks.js';
import { useAppDispatch } from '../../hooks/redux/index.js';
import { ModalWrapper } from '../../wrappers/Modal/index.js';
import { withReduxProvider } from '../../store/providers.js';
export const Modal = (props) => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(initializeApp(props));
    }, []);
    return _jsx(ModalWrapper, {});
};
export const ModalContainer = withReduxProvider(Modal);
//# sourceMappingURL=Modal.js.map